import { render, staticRenderFns } from "./exaStoreDiglog.vue?vue&type=template&id=2ff8ebb0&scoped=true"
import script from "./exaStoreDiglog.vue?vue&type=script&lang=js"
export * from "./exaStoreDiglog.vue?vue&type=script&lang=js"
import style0 from "./exaStoreDiglog.vue?vue&type=style&index=0&id=2ff8ebb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff8ebb0",
  null
  
)

export default component.exports